module.exports = __webpack_public_path__ + "static/media/resourceDocument.524bbfe5.svg";